import React, {useContext} from "react";
import {FormDataContext} from "../../contexts/FormDataContext";
import {
  Checkbox, FormControlLabel,
} from '@mui/material';
import { SectionHeading } from '../SectionHeading';
import { SectionPaper } from '../SectionPaper';

export const Education = () => {
  const {
    selectedDegrees,
    setSelectedDegrees,
    preferencesFormDisabled,
    setIsFormDataChanged,
    degrees,
  } = useContext(FormDataContext);

  const handleDegreeChange = event => {
    const isChecked = event.target.checked;
    const value = event.target.value;
    if (isChecked) {
      setSelectedDegrees(prevDegrees => [...prevDegrees, value])
    } else {
      setSelectedDegrees(prevDegrees => prevDegrees.filter(degreeKey => degreeKey !== value));
    }
    setIsFormDataChanged(true);
  };

  return (
    <>
      <SectionHeading>
        Education Level
      </SectionHeading>
      <SectionPaper>
        {Object.entries(degrees).map(([key, label]) => (
          <div key={`degree${key}`}>
            <FormControlLabel
              key={`label${key}`}
              control={<Checkbox/>}
              label={label}
              value={key}
              checked={selectedDegrees.includes(key)}
              onChange={handleDegreeChange}
              disabled={preferencesFormDisabled}
            />
        </div>
        ))}
      </SectionPaper>
    </>
  );
};
